import { CircularProgress } from '@mui/material';
import { FC } from 'react';

interface MaterialCircularProgressProps {
  height?: string;
  size?: number;
  message?: string;
}

export const MaterialCircularProgress: FC<MaterialCircularProgressProps> = ({
  height = '100vh',
  size = 72,
  message = '',
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        height,
      }}
    >
      {message && <div>{message}</div>}
      <CircularProgress
        size={size}
        sx={{ color: 'var(--brand-accent, red)' }}
      />
    </div>
  );
};
